import { Injectable } from '@angular/core';
import { PropertyViewConfig } from './feed-settings.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../models/core.models';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceSettingsService {
  private workspaceConfiguration;
  private configLoaded = false;

  constructor(private translate: TranslateService) {}

  async initializeConfigurations(): Promise<void> {
    const keys = [
      'workspace.view-settings.time-created',
      'workspace.view-settings.time-modified',
    ];

    const translations = await this.translate.get(keys).toPromise();

    const workspaceProperties: PropertyViewConfig[] = [
      {
        label: translations['workspace.view-settings.time-created'],
        path: 'time_created',
        propertyUri: 'time_created',
        icon: ['fas', 'clock'],
        selected: false,
        visibility: ['tools'],
        isRadio: false,
      },
      {
        label: translations['workspace.view-settings.time-modified'],
        path: 'time_modified',
        propertyUri: 'time_modified',
        icon: ['fas', 'clock'],
        selected: false,
        visibility: ['tools'],
        isRadio: false,
      },
    ];

    this.workspaceConfiguration = [...workspaceProperties];
    this.configLoaded = true;
  }

  getWorkspaceViewConfig(user: User): Promise<PropertyViewConfig[]> {
    return new Promise(async (resolve) => {
      if (!this.configLoaded) {
        await this.initializeConfigurations();
      }
      let workspaceConfig = this.workspaceConfiguration;
      if (workspaceConfig) {
        workspaceConfig = workspaceConfig.filter((config) => {
          return (
            !config.permission || user?.feature_components[config.permission]
          );
        });
      }
      resolve(workspaceConfig);
    });
  }
}
